import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap, Coins, LogOut, User, Trophy, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (p) => location.pathname === p;
  const link = (to, label) => (
    <Link
      to={to}
      data-testid={`nav-${label.toLowerCase()}`}
      className={`text-sm font-medium tracking-wide transition-colors ${
        isActive(to) ? "text-[#FBBF24]" : "text-zinc-300 hover:text-white"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-[#FBBF24] flex items-center justify-center shadow-[0_0_20px_-4px_#FBBF24]">
            <Zap size={20} className="text-black" strokeWidth={3} />
          </div>
          <span className="font-display font-extrabold text-lg tracking-tighter">
            penniesonda<span className="text-[#FBBF24]"> Dalla</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {link("/", "Auctions")}
          {link("/winners", "Winners")}
          {user && typeof user === "object" && link("/dashboard", "Dashboard")}
          {user && typeof user === "object" && link("/shipping", "Shipping")}
          {user?.role === "admin" && link("/admin", "Admin")}
        </nav>

        <div className="flex items-center gap-3">
          {user && typeof user === "object" ? (
            <>
              <Link
                to="/wallet"
                data-testid="nav-wallet"
                className="flex items-center gap-2 px-3 py-2 rounded-full bg-[#1A1A24] border border-white/10 hover:border-[#FBBF24]/40 transition"
              >
                <Coins size={16} className="text-[#FBBF24]" />
                <span className="font-mono-nums text-sm font-bold" data-testid="nav-token-balance">
                  {user.tokens}
                </span>
              </Link>
              <button
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="nav-logout"
                className="btn-outline flex items-center gap-2 text-sm"
              >
                <LogOut size={14} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="btn-outline text-sm">
                Login
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="btn-bid text-sm !px-5 !py-2"
              >
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
